import { Formik, FormikConfig, FormikHelpers, FormikValues, yupToFormErrors } from "formik";
import { useState } from "react";
import { InferType, ValidationError } from "yup";

const FormikWrapper = <T extends FormikValues>({ validationSchema, onSubmit, ...rest }: FormikConfig<T>) => {
    const [submittedOnce, setSubmittedOnce] = useState(false);

    type FormValues = InferType<typeof validationSchema>;

    const handleSubmit = async (values: T, helpers: FormikHelpers<T>) => {
        setSubmittedOnce(true);

        try {
            await validationSchema.validate(values, { abortEarly: false });
            onSubmit?.(values, helpers);
        } catch (err) {
            if (err instanceof ValidationError) {
                const formikErrors = yupToFormErrors<FormValues>(err);
                helpers.setErrors(formikErrors);
            }
        }
    }

    return (
        <Formik
            {...rest}
            validationSchema={submittedOnce ? validationSchema : undefined}
            validateOnChange={submittedOnce}
            onSubmit={handleSubmit}
        />
    );
}

export default FormikWrapper;